// 폼 필드 (시안 .fld) — 라벨 11/700 + 입력 + 힌트. props: label, hint, required, children, style (래퍼 보정)
import React from 'react';
import { S, T, FONT } from '../theme';

function Field(props) {
  return (<div className="v2-fld" style={props.style}>
    {props.label ? <label style={S.label}>{props.label}{props.required ? <span style={{ color: T.danger, marginLeft: 2 }}>*</span> : null}</label> : null}
    {props.children}
    {props.hint ? <div style={{ fontSize: FONT.label, color: T.faint, marginTop: 3 }}>{props.hint}</div> : null}
  </div>);
}

export default Field;
